import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MapService} from './map.service';
import {UntypedFormControl} from '@angular/forms';
import {NgxSpinnerService} from 'ngx-spinner';
import {BlankDialogComponent} from '../dialogs/blank-dialog/blank-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ShapeFileImportDialog} from './shape-file-import-dialog.component';

@Component({
  selector: 'app-shape-file-import',
  template: `
    <mat-form-field style="width: 100%;">
      <mat-label>{{'MAP.SHAPE_FILE_IMPORT' | translate}}</mat-label>
      <button mat-icon-button matPrefix (click)="f_input.click()">
        <mat-icon>attach_file</mat-icon>
      </button>
      <input type="text" readonly matInput [formControl]="display"/>
      <input id="f_input"
        type="file"
        hidden
        #f_input
        (change)="importShape(f_input)"
      />
      <mat-error>{{'MAP.FIELD_REQUIRED' | translate}}</mat-error>
    </mat-form-field>
    <button mat-stroked-button color="primary" *ngIf="geoJson"
            (click)="showShapeFileImportDialog(geoJson)">{{'MAP.SELECT_FEATURE' | translate}}
    </button>
  `
})
export class ShapeFileImportComponent{

  display: UntypedFormControl = new UntypedFormControl("");

  @Output() importedData: EventEmitter<any> = new EventEmitter();
  @Output() onAttributesGet : EventEmitter<any> = new EventEmitter();
  @Output() onUploadData: EventEmitter<any> = new EventEmitter();
  // 'local', 'remote_get_attributes', 'remote'
  @Input() uploadType = 'local'
  @Input() mappingBody = {keyColumn: '', mapping: {}}
  @Input() layer = ''
  geoJson
  file

  constructor(private mapService: MapService,
              private spinner: NgxSpinnerService,
              private dialog: MatDialog) {}

  browseFile(){
    document.getElementById('f_input').click()
  }

  importShape($e): void {
    this.spinner.show()
    this.file = $e.files[0]
    if (this.file)
      this.display.patchValue(this.file.name);
    if (this.uploadType == 'local') {
      this.mapService.importShape$(this.file).then(data => {
        this.geoJson = data;
        this.showShapeFileImportDialog(data)
      }).finally(() => {this.fileReset()});
    }else if (this.uploadType == 'get_attributes'){
      this.mapService.getAttributesFromShapeFile$(this.file).then(data => {
        this.onAttributesGet.emit(data)
        this.spinner.hide()
      })
    }
  }

  upload(){
    this.spinner.show()
    this.mapService.uploadShapeFile$(this.layer, this.file, this.mappingBody).then(data => {
      this.onUploadData.emit(data)
    }).finally(() => {this.fileReset()});
  }

  fileReset(){
    this.spinner.hide()
    this.mappingBody = {keyColumn: '', mapping: {}}
    this.layer = ''
  }

  showShapeFileImportDialog(geoJson){
    let actionButtons = [
      // {
    //   label: "ACTION.APPLY",
    //   action: 'SAVE',
    //   color: 'primary',
    // },
      {
        label: "ACTION.CLOSE",
        action: 'CANCEL',
        color: 'warn',
      }
    ]
    let data = {
      geoJson
    }

    const dialogRef = this.dialog.open(BlankDialogComponent, {
      width: '', panelClass: '',
      data: {
        component: ShapeFileImportDialog,
        data,
        actionButtons,
        listeners: ['onRowClick']
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.importedData.next(result)
    });
  }



}
